import EmptyView from "common/Empty/EmptyView";
import React from "react";
import useMedia from "utils/hooks/useMedia.ts";
import { MOBILE_SEARCH } from "common/constants.ts";
import { EmptyStatesType } from "common/Icons/types.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { useTheme } from "styled-components";
import PanelEmpty from "common/Empty/PanelEmpty";

import { LanguageNameSpaces } from "@shared/types";

interface EarningEmptyStateProps {
  isSearch?: boolean;
}

const EarningsEmptyState = ({ isSearch }: EarningEmptyStateProps) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);
  const { t: tCommon } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const { isNewLook } = useTheme();

  // New look: inside the table's panel, a short title and one line.
  if (isNewLook)
    return isSearch ? (
      <PanelEmpty
        title={tCommon("empty.no_results_matching_search", {
          objectName: t("earnings.title").toLowerCase(),
        })}
      />
    ) : (
      <PanelEmpty
        title={t("empty.no_earnings")}
        description={t("earnings.empty_description")}
        data-testid="affiliation-empty"
      />
    );

  return (
    <EmptyView
      title={t("empty.no_earnings")}
      iconKey={EmptyStatesType.Coins}
      iconWidth={isMobile ? 100 : 140}
      isSearch={isSearch}
    />
  );
};

export default EarningsEmptyState;
